@if (hasBookAccessCode) {
    <div class="current-code">
        <p>
            @if (userDataService.hasDifferentPremiumCode()) {
                <span>
                    Info: Aktuell wird folgender Stickercode im Buch genutzt<br/>
                </span>
            }
            @if (!userDataService.hasDifferentPremiumCode()) {
                <span>
                    Info: Aktuell ist bereits ein Stickercode im Buch eingelöst:<br/>
                </span>
            }
            Stickercode: <b>{{ applicationStateService.userData.bookAccessCode.quickLink }}</b><br/>
            <span class="red">(Lizenz ohne PLUS/Normal-Features)</span>
        </p>
        @if (userDataService.hasDifferentPremiumCode()) {
            <div>
                <p style="margin-bottom: 0;">
                    Es wurden mehrere Stickercodes zu diesem Buch eingelöst.<br/>
                    Einen anderen Stickercode für dieses Buch nutzen?<br/>
                    <button (click)="onChangeAccessCodeClicked()" class="btn btn-custom-red">
                        Stickercode tauschen
                    </button>
                </p>
            </div>
        }
    </div>
}
<div>
    @if (successMessage) {
        <div class="alert alert-success"
             style="margin-bottom: 10px; padding: 8px 12px; border-radius: 4px;">{{ successMessage }}
        </div>
    }
    @if (errorMessage) {
        <div class="alert alert-danger"
             style="margin-bottom: 10px; padding: 8px 12px; border-radius: 4px;">{{ errorMessage }}
        </div>
    }
    @if (applicationStateService.userData.bookAccessCode?.canUpgrade) {
        <a [href]="getUpgradeRoute(applicationStateService.userData.bookAccessCode.quickLink)" class="btn btn-buy-store" target="_blank">
            <img [src]="'/sidebar-quicklinks/store-at-logo.png' | asset" alt="Store.at" height="25" width="25">
            Upgrade auf Store.at kaufen
        </a>
    } @else if (applicationStateService.bookConfig.storeLink) {
        <div>Du hast noch keinen PLUS-Stickercode?</div>
        <a [href]="applicationStateService.bookConfig.storeLink" class="btn btn-buy-store" target="_blank">
            <img [src]="'/sidebar-quicklinks/store-at-logo.png' | asset" alt="Store.at" height="25" width="25">
            PLUS-Lizenz auf Store.at kaufen
        </a>
    } @else {
        <a href="https://store.at" class="btn btn-buy-store" target="_blank">
            <img [src]="'/sidebar-quicklinks/store-at-logo.png' | asset" alt="Store.at" height="25" width="25">
            PLUS-Lizenz auf Store.at kaufen
        </a>
    }
    @if (trialAvailable) {
        <div class="or-separator" style="margin: 10px 0; font-weight: bold; text-align: center;">ODER</div>
        <button (click)="onStartTrialClicked()" class="btn btn-lem-green">
            Testversion starten ({{ trialDays }} Tage kostenlos)
        </button>
    }
</div>
